import { useCallback, useMemo } from 'react';
import { useDrawerContext } from '../context';

type UseDrawerButtonsResult = {
  isCancelButtonClicked: boolean;
  toggleCancelButtonClicked: () => void;
};

const useDrawerButtons = (): UseDrawerButtonsResult => {
  const { isCancelButtonClicked, setCancelButtonClicked } = useDrawerContext();

  const toggleCancelButtonClicked = useCallback((): void => {
    setCancelButtonClicked((prevCancelButtonClicked) => !prevCancelButtonClicked);
  }, []);

  return useMemo(
    () => ({
      isCancelButtonClicked,
      toggleCancelButtonClicked,
    }),
    [isCancelButtonClicked, toggleCancelButtonClicked]
  );
};

export default useDrawerButtons;
